var _style, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpidsIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ersion: 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: "700px",
    height: "160px",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .small {\n            font-size: 700%;\n            fill: white;\n            background-color: black;\n            font-weight: 700;\n            justify-content: center;\n        }\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "black"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 120,
    className: "small",
    fontFamily: "Arial"
  }, "UPIDS.IO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpidsIo);
export default __webpack_public_path__ + "static/media/upidsIo.456bcaac5368e3cbdffa65443c87b584.svg";
export { ForwardRef as ReactComponent };